import React from "react";

export default class BookingWizard extends React.Component {
  constructor(props) {
    super(props);

    this.wrapperRef = React.createRef();
    this.onChange = this.onChange.bind(this);
  }

  render() {
    
    const {
      close_modal_button = false,
      step = "",
      products = [],
      products_menu_visible = false,
      products_menu_label = "",
      reservation_segments = [],
      vouchers = [],
      vouchers_menu_visible = false,
      vouchers_menu_label = "",
      daily_rentals_menu_visible = false,
      daily_rentals_menu_label = "",
    } = this.props;

    const accommodations_disabled = vouchers && vouchers.length;
    const daily_disabled = vouchers && vouchers.length;
    const add_ons_disabled = (reservation_segments && reservation_segments.length == 0) || (vouchers && vouchers.length);
    const vouchers_disabled = reservation_segments && reservation_segments.length;
    const total_disabled = (reservation_segments && reservation_segments.length == 0) && (vouchers && vouchers.length == 0);
    
    return (
      <div className="BookingWizard">
        <div className="steps">
          <ul className="nav nav-wizard" ref={this.wrapperRef}>
            <li
              title={accommodations_disabled ? I18n.t('clear_cart_to_add') : ''}
              data-tooltip="off"
              className={
                (step == "accommodations" ? "active " : "") +
                (accommodations_disabled ? "disabled" : "")
              }
            >
              <a href="#" onClick={this.onChange.bind(this, "accommodations")}>
                <span className="title">{I18n.t("accommodations")}</span>
              </a>
            </li>
            {
              daily_rentals_menu_visible 
              ? 
              <li 
                className={
                  (step == 'daily-rentals' ? 'active' : '') +
                  (daily_disabled ? 'disabled' : '')
                }
              >
                <a href="#" onClick={this.onChange.bind(this, 'daily-rentals')}>
                  <span className="title">{daily_rentals_menu_label}</span>
                </a>
              </li> 
              : 
              null
            }

            {vouchers_menu_visible ? (
              <li
                title={vouchers_disabled ? I18n.t('clear_cart_to_add') : ''}
                data-tooltip="off"
                className={
                  (step == "vouchers" ? "active " : "") +
                  (vouchers_disabled
                    ? "disabled"
                    : "")
                }
              >
                <a
                  href="#"
                  className="vouchers"
                  onClick={this.onChange.bind(this, "vouchers")}
                >
                  <span className="title">
                    {vouchers_menu_label}
                  </span>
                </a>
              </li>
            ) : null}
            {products && products.length && (reservation_segments && reservation_segments.length > 0) ? (
              <li
                title={add_ons_disabled ? I18n.t('clear_cart_to_add') : ''}
                data-tooltip="off"
                className={
                  (step == "add-ons" ? "active " : "") +
                  (add_ons_disabled
                    ? "disabled"
                    : "")
                }
              >
                <a href="#" onClick={this.onChange.bind(this, "add-ons")}>
                  <span className="title">{I18n.t("add_ons")}</span>
                </a>
              </li>
            ) : null}
            {products_menu_visible ? (
              <li className={step == "products" ? "active" : ""}>
                <a
                  href="#"
                  className="products"
                  onClick={this.onChange.bind(this, "products")}
                >
                  <span className="title">
                    {products_menu_label}
                  </span>
                </a>
              </li>
            ) : null}
            {
              reservation_segments &&
              reservation_segments.length == 0 &&
              vouchers &&
              vouchers.length == 0
              ?
              null
              :
              <li
                title={total_disabled ? I18n.t('clear_cart_to_add') : ''}
                data-tooltip="off"
                className={
                  (step == "total" ? "active " : "") +
                  (total_disabled
                    ? "disabled"
                    : "")
                }
              >
                <a href="#" onClick={this.onChange.bind(this, "total")}>
                  <span className="title">{I18n.t("total")}</span>
                </a>
              </li>       
            }
          </ul>

          {close_modal_button ? (
            <div className="modal-header-close-wrapper">
              <div
                className="close-icon-wrapper"
                style={{ padding: "2px 9px", margin: "-4px" }}
              >
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  title="Close without saving"
                >
                  {" "}
                  <span
                    aria-hidden="true"
                    style={{ position: "relative", top: "-1px" }}
                  >
                    ×
                  </span>{" "}
                  <span className="sr-only">Close</span>{" "}
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  onChange(step, _event) {
    if (
      (step == "total" || step == "add-ons") &&
      this.props.reservation_segments &&
      this.props.reservation_segments.length == 0 &&
      this.props.vouchers &&
      this.props.vouchers.length == 0
    ) {
      // can't navigate to total tab if you don't have any reservation segments
      return;
    }

    

    this.props.onChange(
      step,
      this.props.step == "success"
        ? this.props.onViewAccomidationsAfterBookingSuccessCallback
        : null
    );
  }
}
